<template>
  <div>
    <CRow>
      <CCol sm="12">
        <AssetTypesTable
          :items="asset_types"
          hover
          striped
          border
          small
          fixed
          caption="Tipos de Activo"
          @refresh="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import AssetTypesTable from '../../components/asset_types/AssetTypesTable.vue'
import ws from '../../services/asset_types';
import store from '../../store'

export default {
  name: 'AssetTypes',
  components: { AssetTypesTable },
  data: function () {
		return {
            asset_types: []
        }
  },
  mounted: async function() {
    this.loading();
    let response = await ws.get();

    if(response.type == "success"){
      this.asset_types = response.data;
    }

    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      this.asset_types = await items;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
